import { Controller } from "@hotwired/stimulus"
import { motion, reducedMotion } from "../libs/motion"

// Time to read the "Drag the card onto a week" prompt before anything moves.
const READING_TIME = 1500
const NUDGES = 2

// A card that has just arrived leans towards the calendar and springs back, twice, so the
// prompt above it points at something. Pressing the card stops it, before a drag lifts it.
export default class extends Controller {
  connect() {
    if (reducedMotion()) return

    this.element.addEventListener("pointerdown", this.halt, { capture: true, once: true })
    this.timer = setTimeout(() => this.nudge(), READING_TIME)
  }

  disconnect() {
    this.halt()
  }

  halt = () => {
    this.halted = true
    clearTimeout(this.timer)
    this.animation?.cancel()
  }

  async nudge() {
    try {
      for (let i = 0; i < NUDGES && !this.halted; i++) await this.lean()
    } catch {
      // Halted mid-lean: the cancelled animation's promise rejects.
    }
  }

  async lean() {
    const out = this.animation = this.element.animate(
      [ { transform: "none" }, { transform: "translateX(8px)" } ], { ...motion("smooth"), fill: "forwards" }
    )
    await out.finished

    const back = this.animation = this.element.animate(
      [ { transform: "translateX(8px)" }, { transform: "none" } ], motion("spring")
    )
    out.cancel()
    await back.finished
  }
}
